export const ticketsReducer = (state = {loading: false, result: null } , action) => {
    switch (action.type) {
        case 'TICKET_EMAIL_SEND':
            return {
                ...state,
                loading:false,
                result: action.payload,
        }
        case 'TICKET_RESET_RESULT':
            return {
                ...state,
                result: null,
        }
        default:
            return state
    }
}